<template>
    <v-container>
        <v-row class="row">
            <v-col/>
            <v-col class="col" style="width: 800px">
                <Marquee v-for="idx in itemCount"
                         :items="[text.slice(0, (idx+1)*30 )]"
                         :key="idx"
                         :style="{
                             'font-family':fontFamilies[idx % fontFamilies.length],
                         }"/>
                <textarea v-model="text" rows="5" cols="60"></textarea>
            </v-col>
            <v-col/>
        </v-row>
    </v-container>
</template>

<script>
    import Marquee from "../../components/Marquee";

    export default {
        name: "MarqueeTest",
        components: {
            Marquee,
        },
        data() {
            return {
                fontFamilies: ['serif', 'cursive', 'system-ui', 'sans-serif',],
                itemCount: 30,
                text: " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus maximus nisi vitae nisl accumsan vulputate. Phasellus porttitor purus quis sodales luctus. Maecenas rutrum lorem ut odio posuere elementum. Curabitur sit amet nibh imperdiet, sollicitudin orci suscipit, lobortis metus. Praesent molestie, felis eu hendrerit imperdiet, massa ex ultrices mi, ac porta velit nunc eu ante. Donec sodales consequat pulvinar. Phasellus ornare volutpat tempus. Sed augue dolor, feugiat ac tortor at, rutrum egestas neque. Nulla in urna nec neque consectetur laoreet. Phasellus elementum, libero quis vulputate congue, sapien nibh accumsan felis, in condimentum felis lacus nec sem. Aliquam ac feugiat nunc. Aenean eu nulla sed erat commodo efficitur sit amet at magna." +
                    "Sed in dapibus ante. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris varius laoreet dignissim. Aenean a tristique velit, sed dictum elit. Maecenas sagittis neque leo, vitae hendrerit purus rutrum sed. Proin quis ex bibendum, faucibus magna nec, convallis nisl. Duis rhoncus ex sed quam pellentesque rutrum. Proin rhoncus, tellus non facilisis interdum, ante libero tincidunt justo, laoreet pharetra odio mi in quam." +
                    "Nam consequat turpis in ipsum dapibus, vitae condimentum odio cursus. Praesent eu eleifend ante. Aenean porttitor justo sit amet sagittis bibendum. Sed ultricies, eros ut finibus consectetur, diam metus fringilla ex, quis auctor elit nisi id leo. Nam lectus risus, lobortis id lectus quis, vehicula porttitor nunc. Proin egestas leo sodales rutrum finibus. Sed gravida commodo orci et lobortis. "
            };
        },
        methods: {
        },
        created() {

        },
        mounted() {
        }
    };
</script>

<style scoped>

.row>* {
    border: crimson 1px solid;
    /*letter-spacing: 40px;*/
}
</style>
